import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import routes from '../../../routes';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import {
  COURSE_STATS_GET,
  STATS_USERS_RESET,
} from '../../redux/actions/statistics';
import CourseStatsHero from './CourseStatsHero';
import { Tabs } from '../../../ui/atoms';
import Activities from './Activities';
import Survey from './Survey';
import Sessions from './Sessions';
import Users from './Users';

const defaultTabs = [
  {
    value: 'sessioni',
    label: 'Sessioni',
    icon: 'layers-three-02',
  },
  {
    value: 'attività',
    label: 'Attività',
    icon: 'puzzle-piece-01',
  },
  { value: 'utenti', label: 'Utenti', icon: 'users-01' },
  { value: 'survey', label: 'Survey', icon: 'bar-chart-12' },
];

const CourseStatistics = ({
  mediaIsPhone,
  mediaIsTablet,
  data,
  getCourseStats,
  resetUsers,
}) => {
  const { course_id, tab_name } = useParams();
  const navigate = useNavigate();
  // tabs
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    if (mediaIsPhone || mediaIsTablet) navigate(routes.statistics.path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaIsPhone, mediaIsTablet]);

  useEffect(() => {
    if (tab_name) {
      const currentTab = defaultTabs.find((t) => t.value === tab_name);
      if (currentTab) {
        setActiveTab(currentTab);
        return;
      }
    }
    navigate(
      `${routes.courseStatistics.path}/${course_id}/${defaultTabs[0].value}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab_name]);

  useEffect(() => {
    if (!course_id) navigate(routes.statistics.path);
    else {
      window.scrollTo(0, 0);
      getCourseStats(course_id);
    }
    return () => resetUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course_id]);

  useEffect(() => {
    if (data) {
      let newTabs;
      if (data?.typology === 'course') {
        newTabs = [...defaultTabs.filter((tab) => tab?.value !== 'sessioni')];
      } else if (data?.typology === 'event') {
        newTabs = [...defaultTabs.filter((tab) => tab?.value !== 'attività')];
      } else {
        newTabs = [
          ...defaultTabs.filter(
            (tab) => !['attività', 'sessioni'].includes(tab?.value)
          ),
        ];
      }
      setTabs(newTabs || defaultTabs);
    }
  }, [data]);

  const getCurrentTab = (tab) => {
    switch (tab) {
      case 'survey':
        return <Survey />;
      case 'attività':
        return <Activities />;
      case 'sessioni':
        return <Sessions />;
      case 'utenti':
      default:
        return <Users />;
    }
  };

  return (
    <div id="coursePage">
      <Breadcrumb
        crumbs={[
          {
            label: 'Statistiche',
            onClick: () => navigate(routes.statistics.path),
          },
          {
            label: `Percorso formativo: ${data?.title || ''}`,
          },
        ]}
      />
      <CourseStatsHero data={data} />
      <Tabs
        tabs={tabs}
        selected={activeTab}
        onChange={({ value }) => {
          navigate(`${routes.courseStatistics.path}/${course_id}/${value}`);
        }}
      />
      {getCurrentTab(activeTab?.value)}
    </div>
  );
};

CourseStatistics.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // state
  data: PropTypes.object,
  // dispatch
  getCourseStats: PropTypes.any,
  resetUsers: PropTypes.func,
};

export default connect(
  (state) => {
    const { course: data } = state.statistics;
    return {
      data,
    };
  },
  (dispatch) => ({
    getCourseStats: (course_id) =>
      dispatch({ type: COURSE_STATS_GET._REQUEST, course_id }),
    resetUsers: () => dispatch({ type: STATS_USERS_RESET }),
  })
)(withMediaQueries(CourseStatistics));
